import React, { ReactElement, ComponentType } from 'react';
import { RouteProps, Route, Redirect } from 'react-router-dom';
import { useAuth } from 'contexts/auth-context';
import { LOGIN_PATH } from 'constants/paths';

import isEmpty from 'lodash/isEmpty';
import PageLoader from 'components/page-loader/page-loader';
import useNav from 'hooks/nav';

interface PrivateRouteProps extends RouteProps {
  component: ComponentType;
}

export default function PrivateRoute(props: PrivateRouteProps): ReactElement {
  const { authState, isLoading } = useAuth();
  const { locale } = useNav();
  if (isLoading) {
    return <PageLoader />;
  } else {
    const localePath = locale !== '' ? `/${locale}${LOGIN_PATH}` : LOGIN_PATH;
    const component =
      !isEmpty(authState) && authState?.userSession
        ? props.component
        : () => <Redirect to={localePath} />;
    return (
      <Route path={props.path} exact={props.exact} component={component} />
    );
  }
}
